<template>
  <div class="left-box">
    <div class="left-title d-aligncnter d-between">
      <div class="d-aligncnter" v-if="canChose">
        <!-- <img src="@/assets/img/cockpit/running.svg" style="margin-right: 8px" /> -->
        <div>日锻炼人数</div>
      </div>
      <div v-else>昨日锻炼人数</div>
      <div class="select-option" v-if="canChose">
        <el-date-picker
          v-model="currDate"
          type="date"
          placeholder="选择日期"
          :clearable="false"
          @change="DayDateChange"
          :picker-options="maxOptions"
        >
        </el-date-picker>
      </div>
    </div>
    <table class="left-table" cellspacing="0">
      <tr class="t-head">
        <!-- <td class="td-1">序号</td> -->
        <td class="td-2">学院名称</td>
        <td class="td-3">总人数</td>
        <td class="td-3">锻炼人数</td>
        <td class="td-4">锻炼百分比</td>
      </tr>
    </table>
    <div
      style="height: 342px; overflow: hidden"
      @mouseenter="stopScroll"
      @mouseleave="startScroll"
      v-if="type == 'eachVenue'"
    >
      <table class="left-table" cellspacing="0" :class="{ 'animated-top': animatedTop && this.runData.length > 9 }">
        <tr
          class="tr-data"
          :class="{
            'color-tr': getBgClass(index),
            'mt-20': index == runData.length - 1,
          }"
          v-for="(item, index) in runData"
          :key="'run_' + index"
        >
          <!-- <td class="td-1">{{ item.sortCode }}</td> -->
          <td class="college-name td-2 overflow">
            {{ item.collegeName }}
          </td>
          <td class="td-3">{{ item.studentNum }}</td>
          <td class="td-3">{{ item.lastRunCount }}</td>
          <td class="td-4">{{ item.ratio }}%</td>
        </tr>
      </table>
    </div>
    <div style="height: 282px; overflow: hidden" @mouseenter="stopScroll" @mouseleave="startScroll" v-else>
      <table class="left-table" cellspacing="0" :class="{ 'animated-top': animatedTop && this.runData.length > 9 }">
        <tr
          class="tr-data"
          :class="{
            'color-tr': getBgClass(index),
            'mt-20': index == runData.length - 1,
          }"
          v-for="(item, index) in runData"
          :key="'run_' + index"
        >
          <!-- <td class="td-1">{{ item.sortCode }}</td> -->
          <td class="college-name td-2 overflow">
            {{ item.collegeName }}
          </td>
          <td class="td-3">{{ item.studentNum }}</td>
          <td class="td-3">{{ item.lastRunCount }}</td>
          <td class="td-4">{{ item.ratio }}%</td>
        </tr>
      </table>
    </div>
    <table v-if="!!todaySumChange">
      <tr class="tr-data color-tr">
        <td class="college-name td-2 overflow">合计</td>
        <td class="td-3">{{ todaySumChange.num }}</td>
        <td class="td-3">{{ todaySumChange.exercise }}</td>
        <td class="td-4">{{ todaySumChange.rate }}%</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: ['dayCollegeData', 'len', 'dayDate', 'canChose', 'todaySumChange', 'type'],
  data() {
    return {
      runData: [
        // { name: '计算机与计算科学', totalNum: 200, errorNum: 5 },
        // { name: '信息与电气工程', totalNum: 200, errorNum: 5 },
        // { name: '商学院', totalNum: 200, errorNum: 5 },
        // { name: '计算机与计算科学', totalNum: 200, errorNum: 5 },
        // { name: '信息与电气工程', totalNum: 200, errorNum: 5 },
        // { name: '商学院', totalNum: 200, errorNum: 5 },
        // { name: '计算机与计算科学', totalNum: 200, errorNum: 5 },
        // { name: '信息与电气工程', totalNum: 200, errorNum: 5 },
        // { name: '商学院', totalNum: 200, errorNum: 5 },
        // { name: '计算机与计算科学3', totalNum: 200, errorNum: 5 },
        // { name: '信息与电气工程2', totalNum: 200, errorNum: 5 },
        // { name: '商学院1', totalNum: 200, errorNum: 5 },
      ],
      animatedTop: false,
      timer: null,
      flag: true,
      modeData: 0,
      currDate: '',
      maxDate: new Date(),
      maxOptions: {
        disabledDate(time) {
          if (time.getTime() > Date.now()) {
            return true
          } else {
            return false
          }
        },
      },
    }
  },
  watch: {
    dayCollegeData: {
      handler: function () {
        this.runData = this.dayCollegeData
        this.currDate = this.dayDate
        // if(this.flag){
        //     for (let i = 0; i < this.runData.length; i++) {
        //         this.runData[i].code = i + 1
        //     }
        //     this.flag = false
        // }
      },
      deep: true,
    },
  },
  created() {
    this.runData = this.dayCollegeData

    // let getMyDate = new Date()
    // this.currDate = getMyDate.getTime()
    // let nowDate = new Date()
    // let date = {
    //   year: nowDate.getFullYear(),
    //   month: nowDate.getMonth() + 1,
    //   date: nowDate.getDate(),
    //   hours: nowDate.getHours(),
    //   minutes: nowDate.getMinutes(),
    //   seconds: nowDate.getSeconds(),
    // }
    // let newmonth = date.month > 9 ? date.month : '0' + date.month
    // let newday = date.date > 9 ? date.date : '0' + date.date
    // this.currDate = date.year + '-' + newmonth + '-' + newday
    // if (this.dayCollegeData.length > 10) {
    //   this.runData = [...this.dayCollegeData, ...this.dayCollegeData]
    // } else {
    //   this.runData = this.dayCollegeData
    // }
  },
  mounted() {
    const that = this
    setTimeout(() => {
      for (let i = 0; i < that.runData.length; i++) {
        that.runData[i].code = i + 1
      }
    }, 1000)

    this.timer = setInterval(() => {
      //   console.log('runData:', this.runData)
      if (this.runData.length > this.len) {
        this.animatedTop = true
        setTimeout(() => {
          this.runData.push(this.runData[0])
          this.runData.shift()
          this.animatedTop = false
        }, 500)
      } else {
        this.stopScroll()
      }
    }, 2000)
  },
  computed: {
    getBgClass() {
      return function (index) {
        if (index % 2 == this.modeData) {
          return false
        }
        return true
      }
    },
  },
  methods: {
    stopScroll() {
      clearInterval(this.timer)
      this.timer = null
    },
    startScroll() {
      this.timer = setInterval(() => {
        if (this.runData.length > 9) {
          this.animatedTop = true
          setTimeout(() => {
            this.runData.push(this.runData[0])
            this.runData.shift()
            this.animatedTop = false
          }, 500)
        } else {
          this.stopScroll()
        }
      }, 2000)
    },
    DayDateChange() {
      console.log(this.formatDate(this.currDate))
      this.$emit('changeDayDate', this.formatDate(this.currDate))
      // this.$emit('dayDateChange', this.currDate)
    },
    formatDate(date) {
      var dateObj = new Date(date)
      var year = dateObj.getFullYear().toString()
      var month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
      var day = dateObj.getDate().toString().padStart(2, '0')
      var formattedDate = `${year}-${month}-${day}`
      return formattedDate
    },
  },
}
</script>
<style scoped lang="scss">
.animated-top {
  transition: all 0.5s;
  margin-top: -30px;
}
.left-box {
  width: calc(100% - 48px);
  margin-left: 24px;
  .left-title {
    // font-size: 0.5rem;
    font-size: 22px;
    margin-bottom: 8px;
  }
  .left-table {
    width: calc(100% - 0px);
    // font-size: 0.3rem;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    border-radius: 4px;
  }
}
table {
  font-size: 14px;
  table-layout: fixed;
  width: 100%;
  tr td {
    text-align: center;
    height: 30px;
    // height: 3vh;
  }
  .t-head {
    width: 100%;
    background: linear-gradient(0deg, rgba(6, 88, 58, 0.0884779) -24.83%, #06583a 100%);
    height: 36px;
    // height: 4vh;
  }
  tr {
    width: 100%;
    .td-1 {
      width: 33%;
    }
    .td-2 {
      width: 33%;
    }
    .td-3,
    .td-4 {
      width: 33%;
    }
  }
  .color-tr {
    background: rgba(0, 122, 77, 0.2);
  }
  //   .tr-data {
  //     .college-name {
  //       text-align: left;
  //     }
  //   }
}
.mt-20 {
  margin-bottom: 20px;
}

.select-option ::v-deep .el-input__inner,
.el-select-dropdown__item.is-disabled:hover {
  background-color: rgba(255, 255, 255, 0) !important;
}
.select-option ::v-deep .el-input__inner {
  //   border: 1px solid #007a4d !important;
  height: 36px;
  color: #fff;
  width: 105px;
  border: none;
  padding-right: 0px !important;
}
.select-option ::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 105px;
}
.select-option ::v-deep .el-input__icon {
  line-height: 36px;
}
</style>
